module.exports = __webpack_public_path__ + "static/img/11.3e868d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/eng/11.png
// module id = tSYv
// module chunks = 0